import * as MuiIcons from '@mui/icons-material';

export default MuiIcons;
